<template>
    <v-container>
        <v-layout>
            <v-flex>
                <video ref="video" autoplay></video>
            </v-flex>
            <v-flex>
                <canvas ref="canvas"></canvas>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <p>{{ score }}</p>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "movimiento",
        data() {
            return {
                stream: {},					// stream obtained from webcam
                video: {},					// shows stream
                captureCanvas: {
                    width: 640,
                    height: 480
                },			// internal canvas for capturing full images from video
                captureContext: '',			// context for capture canvas
                diffCanvas: {
                    width: 640,
                    height: 480
                },				// internal canvas for diffing downscaled captures
                diffContext: '',			// context for diff canvas
                motionCanvas: {
                    width: 640,
                    height: 480
                },			// receives processed diff images
                motionContext: '',			// context for motion canvas
                captureInterval: '',		// interval for continuous captures
                captureIntervalTime: 100,	// time between captures, in ms
                captureWidth: 640,			// full captured image width
                captureHeight: 480,			// full captured image height
                diffWidth: 640,				// downscaled width for diff/motion
                diffHeight: 480,				// downscaled height for diff/motion
                isReadyToDiff: '',			// has a previous capture been made to diff against?
                pixelDiffThreshold: 32,		// min for a pixel to be considered significant
                scoreThreshold: 16,			// min for an image to be considered significant
                includeMotionBox: false,		// flag to calculate and draw motion bounding box
                includeMotionPixels: false,	// flag to create object denoting pixels with motion
                score: '',

            }
        },
        mounted() {
            this.video = this.$refs.video;
            this.captureCanvas = document.createElement('canvas');
            this.diffCanvas = document.createElement('canvas');
            this.motionCanvas = this.$refs.canvas;
            // prep capture canvas
            this.captureCanvas.width = this.captureWidth;
            this.captureCanvas.height = this.captureHeight;
            this.captureContext = this.captureCanvas.getContext('2d');
            // prep diff canvas
            this.diffCanvas.width = this.diffWidth;
            this.diffCanvas.height = this.diffHeight;
            this.diffContext = this.diffCanvas.getContext('2d');
            // prep motion canvas
            this.motionCanvas.width = this.diffWidth;
            this.motionCanvas.height = this.diffHeight;
            this.motionContext = this.motionCanvas.getContext('2d');
            this.requestWebcam();
        },
        methods: {
            requestWebcam() {
                let constraints = {
                    audio: false,
                    video: {width: this.captureWidth, height: this.captureHeight}
                };

                navigator.mediaDevices.getUserMedia(constraints)
                    .then(this.initSuccess)
                    .catch(this.initError);
            },

            initSuccess(requestedStream) {
                this.stream = requestedStream;
                this.start();
                // this.initSuccessCallback();
            },

            initError(error) {
                console.log(error);
                // this.initErrorCallback();
            },

            start() {
                if (!this.stream) {
                    throw 'Cannot start after init fail';
                }

                // streaming takes a moment to start
                this.video.addEventListener('canplay', this.startComplete);
                this.video.srcObject = this.stream;
            },

            startComplete() {
                this.video.removeEventListener('canplay', this.startComplete);
                this.captureInterval = setInterval(this.capture, this.captureIntervalTime);
                // this.startCompleteCallback();
            },

            stop() {
                clearInterval(this.captureInterval);
                this.video.src = '';
                this.motionContext.clearRect(0, 0, this.diffWidth, this.diffHeight);
                this.isReadyToDiff = false;
            },

            capture() {
                // save a full-sized copy of capture
                this.captureContext.drawImage(this.video, 0, 0, this.captureWidth, this.captureHeight);
                let captureImageData = this.captureContext.getImageData(0, 0, this.captureWidth, this.captureHeight);

                // diff current capture over previous capture, leftover from last time
                this.diffContext.globalCompositeOperation = 'difference';
                this.diffContext.drawImage(this.video, 0, 0, this.diffWidth, this.diffHeight);
                let diffImageData = this.diffContext.getImageData(0, 0, this.diffWidth, this.diffHeight);

                if (this.isReadyToDiff) {
                    let diff = this.processDiff(diffImageData);

                    this.motionContext.putImageData(diffImageData, 0, 0);
                    if (diff.motionBox) {
                        this.motionContext.strokeStyle = '#fff';
                        this.motionContext.strokeRect(
                            diff.motionBox.x.min + 0.5,
                            diff.motionBox.y.min + 0.5,
                            diff.motionBox.x.max - diff.motionBox.x.min,
                            diff.motionBox.y.max - diff.motionBox.y.min
                        );
                    }
                    this.score = diff.score;
                    this.captureCallback({
                        imageData: captureImageData,
                        score: diff.score,
                        hasMotion: diff.score >= this.scoreThreshold,
                        motionBox: diff.motionBox,
                        motionPixels: diff.motionPixels,
                        getURL: (r) => {
                            return this.getCaptureUrl(this.imageData);
                        },
                        checkMotionPixel: (x, y) => {
                            return this.checkMotionPixel(this.motionPixels, x, y)
                        }
                    });
                }

                // draw current capture normally over diff, ready for next time
                this.diffContext.globalCompositeOperation = 'source-over';
                this.diffContext.drawImage(this.video, 0, 0, this.diffWidth, this.diffHeight);
                this.isReadyToDiff = true;
            },
            captureCallback(payload) {

            },
            processDiff(diffImageData) {
                let rgba = diffImageData.data;

                // pixel adjustments are done by reference directly on diffImageData
                let score = 0;
                let motionPixels = this.includeMotionPixels ? [] : undefined;
                let motionBox = undefined;
                for (let i = 0; i < rgba.length; i += 4) {
                    let pixelDiff = rgba[i] * 0.3 + rgba[i + 1] * 0.6 + rgba[i + 2] * 0.1;
                    let normalized = Math.min(255, pixelDiff * (255 / this.pixelDiffThreshold));
                    rgba[i] = 0;
                    rgba[i + 1] = normalized;
                    rgba[i + 2] = 0;

                    if (pixelDiff >= this.pixelDiffThreshold) {
                        score++;
                        this.coords = this.calculateCoordinates(i / 4);

                        if (this.includeMotionBox) {
                            motionBox = this.calculateMotionBox(motionBox, this.coords.x, this.coords.y);
                        }

                        if (this.includeMotionPixels) {
                            motionPixels = this.calculateMotionPixels(motionPixels, this.coords.x, this.coords.y, pixelDiff);
                        }

                    }
                }

                return {
                    score: score,
                    motionBox: score > this.scoreThreshold ? motionBox : undefined,
                    motionPixels: motionPixels
                };
            },

            calculateCoordinates(pixelIndex) {
                return {
                    x: pixelIndex % this.diffWidth,
                    y: Math.floor(pixelIndex / this.diffWidth)
                };
            },

            calculateMotionBox(currentMotionBox, x, y) {
                // init motion box on demand
                let motionBox = currentMotionBox || {
                    x: {min: this.coords.x, max: x},
                    y: {min: this.coords.y, max: y}
                };

                motionBox.x.min = Math.min(motionBox.x.min, x);
                motionBox.x.max = Math.max(motionBox.x.max, x);
                motionBox.y.min = Math.min(motionBox.y.min, y);
                motionBox.y.max = Math.max(motionBox.y.max, y);

                return motionBox;
            },

            calculateMotionPixels(motionPixels, x, y, pixelDiff) {
                motionPixels[x] = motionPixels[x] || [];
                motionPixels[x][y] = true;

                return motionPixels;
            },

            getCaptureUrl(captureImageData) {
                // may as well borrow captureCanvas
                this.captureContext.putImageData(captureImageData, 0, 0);
                return this.captureCanvas.toDataURL();
            },
            checkMotionPixel(motionPixels, x, y) {
                return motionPixels && motionPixels[x] && motionPixels[x][y];
            },

            getPixelDiffThreshold() {
                return this.pixelDiffThreshold;
            },

            setPixelDiffThreshold(val) {
                this.pixelDiffThreshold = val;
            },

            getScoreThreshold() {
                return scoreThreshold;
            },

            setScoreThreshold(val) {
                this.scoreThreshold = val;
            }


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/pcp/movimiento.vue